<template>
    <v-toolbar app :dark="dark" fixed :clipped-left="$vuetify.breakpoint.lgAndUp">
        <v-toolbar-side-icon @click.stop="$toggleDrawer"></v-toolbar-side-icon>
        <v-toolbar-title v-text="title"></v-toolbar-title>

        <v-spacer></v-spacer>

        <v-slide-x-transition>
            <v-tooltip v-show="loaded && hasVideoTutorial" bottom>
                <video-dialog title="Video-Erklärung" :video-source="currentVideoSrc" slot="activator">
                    <v-btn :dark="dark" icon slot="activator">
                        <v-icon>help_outline</v-icon>
                    </v-btn>
                </video-dialog>
                <span>Video Erklärung</span>
            </v-tooltip>
        </v-slide-x-transition>
        <v-tooltip v-if="!$vuetify.breakpoint.xs && loaded && $hasRole('admin')" bottom>
            <v-btn :dark="dark" icon slot="activator" :loading="downloadingEMails" :disabled="downloadingEMails" @click="downloadEMails">
                <v-icon>email</v-icon>
            </v-btn>
            <span>Download E-Mails</span>
        </v-tooltip>
        <v-tooltip v-if="loaded && user && !user.valid" bottom>
            <v-btn :dark="dark" icon slot="activator" @click="$router.push('/user/settings')">
                <v-icon color="yellow">warning</v-icon>
            </v-btn>
            <span>Benutzerdaten unvollständig</span>
        </v-tooltip>
        <v-tooltip v-if="loaded && user && user.real_api_token" bottom>
            <v-btn icon="icon" :dark="dark" slot="activator" @click="resetUser">
                <v-icon>launch</v-icon>
            </v-btn>
            <span>Zurück zum eigenen Profil</span>
        </v-tooltip>

        <v-autocomplete
                v-if="!$vuetify.breakpoint.xs && loaded && $hasRole('admin')"
                v-model="selectedUser"
                :items="items"
                :loading="!users.loaded"
                :placeholder="$t('switch_user')"
                :disabled="switching"
                item-text="selectText"
                return-object
                flat
                hide-no-data
                hide-details
                solo-inverted
                @input="switchUser"
        ></v-autocomplete>

        <!--
        <v-menu bottom left>
            <v-btn icon slot="activator" dark>
                <v-icon>map</v-icon>
            </v-btn>
            <v-list>
                <v-list-tile v-for="language in supportedLanguages" @click="switchLang(language.key)">
                    <v-list-tile-title><span class="flag-icon" :class="language.icon"></span> @{{ language.name }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
        -->
    </v-toolbar>
</template>

<script>
    import ConfirmationDialog from './dialogs/ConfirmationDialog';
    import VideoDialog from './dialogs/VideoDialog';
    import { mapState } from 'vuex';

    export default {
        components: {
            ConfirmationDialog,
            VideoDialog
        },
        data() {
            return {
                loading: false,
                logoutDialog: false,
                switching: false,
                hasVideoTutorial: false,
                drawer: null,
                downloadingEMails: false,
                selectedUser: null,
                supportedLanguages: [
                    {key: 'de', name: 'Deutsch', icon: 'flag-icon-de'},
                    {key: 'en', name: 'English', icon: 'flag-icon-us'}
                ]
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            loaded: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            items() {
                if (this.user.real_api_token !== undefined) {
                    return this.users.items;
                }

                return _.reject(this.users.items, u => {
                    return this.user.id === u.id;
                });
            },
            dark() {
                if (this.user !== null && this.user.hasOwnProperty('white_toolbar')) {
                    return !this.user.white_toolbar;
                }

                return true;
            },
            currentVideoSrc() {
                let path = this.$route.path;
                if (path === '/user/dancer') {
                    return 'https://www.youtube.com/embed/GKk_6HPmWD0';
                } else if (path === '/user/starter-template') {
                    return 'https://www.youtube.com/embed/qAplBReVg4g';
                } else if (path === '/user/events' || path.startsWith('/user/event-registration-list') || path.startsWith('/user/event-registration')) {
                    return 'https://www.youtube.com/embed/1M6Tt-93UUA';
                }

                return '';
            },
            ...mapState(['user', 'users', 'snackBar'])
        },
        watch: {
            user: {
                deep: true,
                handler(val) {
                    if (this.user !== null && this.user.real_api_token && this.users.loaded) {
                        this.selectedUser = _.find(this.users.items, u => u.id === this.user.id);
                    }
                }
            },
            users: {
                deep: true,
                handler(val) {
                    if (this.selectedUser === null && this.user !== null && this.user.real_api_token && this.users.loaded) {
                        this.selectedUser = _.find(this.users.items, u => u.id === this.user.id);
                    }
                }
            },
            $route (to, from){
                this.updateVideoTutorial(to.path);
            }
        },
        mounted() {
            let locale = localStorage.getItem('locale');
            this.switchLang(locale ? locale : 'de');

            this.updateVideoTutorial(this.$router.currentRoute.path);
        },
        methods: {
            switchUser(user) {
                this.switching = true;

                axios.get(`/api/v1/users/${user.id}`).then(response => {

                    if (!response.data.success) {
                        return;
                    }

                    let user = response.data.data;

                    this.$store.commit('switchUser', user);
                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: this.$t('user_switched', [this.selectedUser.selectText])
                    });

                }, errorResponse => {
                    console.error(errorResponse);
                }).finally(() => {
                    this.switching = false;
                });
            },
            resetUser() {
                this.selectedUser = null;
                this.$store.commit('resetUser');

                this.$store.commit('snackBar', {
                    color: 'success',
                    text: this.$t('user_returned')
                });
            },
            downloadEMails() {
                this.downloadingEMails = true;

                axios({
                    url: `/api/v1/emails`,
                    method: 'GET',
                    responseType: 'blob'
                }).then(response => {
                    let disposition = response.headers['content-disposition'];
                    let filename = decodeURI(disposition.match(/filename=(.*)/)[1]);

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();

                    this.downloadingEMails = false;
                }, errorResponse => {
                    this.downloadingEMails = false;
                });
            },
            switchLang(locale) {
                this.$i18n.locale = locale;
                localStorage.setItem('locale', locale);
            },
            updateVideoTutorial(path) {
                if (path.startsWith('/user/event-registration-list') || path.startsWith('/user/event-registration')) {
                    this.hasVideoTutorial = true;
                    return;
                }

                let routes = [
                    '/user/dancer',
                    '/user/starter-template',
                    '/user/events'
                ];

                this.hasVideoTutorial = _.includes(routes, path);
            }
        }
    }
</script>